// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M4.5 2L8.5 6L4.5 10\" stroke=\"%23999\" stroke-width=\"1.5\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FullAnalysis{  
    /*background-color: #f9f9f9;*/
    background-color: #f9f9f6;
    width: 100%;
    height: 100%;
    padding-top: 36px;
    padding-left: 20px;
    padding-right: 34px;
    padding-bottom: 20px;
}

.FullAnalysis_form{
    padding: 10px;
    padding-right: 18px;
}

.FullAnalysis_header{
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
}

.FullAnalysis_title{
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;

    color: #8E9ABB;
}


.FullAnalysis_content{
    display: flex;
    flex-direction: column;
    gap: 33px;
}

.FullAnalysis_breadcrumbs_head{
    display: flex;
    justify-content: space-between;
    align-items: center;
    /*margin-bottom: 33px;*/
}

.FullAnalysis_breadcrumbs{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 2px;
}

.FullAnalysis_breadcrumbs_solaris{
    margin-bottom: 20px;
}

.FullAnalysis_crumb{
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;

    color: #1d1d1f;
    display: flex;
    align-items: center;
    
    /* Minimalistic macOS style */
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(20px);
    border-radius: 6px;
    padding: 4px 8px;
    margin: 1px;
    border: 0.5px solid rgba(0, 0, 0, 0.04);
    
    /* Subtle shadow for depth */
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    
    /* Smooth transitions */
    transition: all 0.15s ease;
    cursor: pointer;
}

.FullAnalysis_crumb:hover{
    background: rgba(255, 255, 255, 0.95);
    border-color: rgba(0, 0, 0, 0.08);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.FullAnalysis_crumb--drop{
    color: #007aff;
    background: rgba(0, 122, 255, 0.12);
    border-color: rgba(0, 122, 255, 0.2);
}

.FullAnalysis_crumb--dropError{
    color: #ff3b30;
    background: rgba(255, 59, 48, 0.12);
    border-color: rgba(255, 59, 48, 0.2);
}


.FullAnalysis_crumb::after{
    content: '';
    display: block;
    margin-left: 6px;
    width: 12px;
    height: 12px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    opacity: 0.6;
}

.FullAnalysis_crumb:last-child{
    font-weight: 500;
    background: rgba(255, 255, 255, 0.95);
    border-color: rgba(0, 0, 0, 0.06);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.FullAnalysis_crumb:last-child::after{
    display: none;
}

.FullAnalysis_crumb:first-child{
    /*if single crumb*/
    font-weight: 400;
}

.FullAnalysis_tabButtons{
    display: flex;
    justify-content: center;
    gap: 5px;
    background: #F3F6FF;
    border-radius: 8px;
    padding: 2px;
    flex-shrink: 0;
}

.FullAnalysis_tabButton{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 12px;
    height: 28px;
    
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #212633;
}

.FullAnalysis_tabButton--active{
    font-weight: 600;
    background: #FFFFFF;
    border: 0.5px solid #E2E9FC;
    box-shadow: 0px 3px 8px rgba(209, 215, 234, 0.12), 0px 3px 1px rgba(209, 215, 234, 0.04);
    border-radius: 8px;
}

.FullAnalysis_files_block{
    container-type: inline-size;
    container-name: FullAnalysis_files;
}

.FullAnalysis_files{
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    --cols: 3;
}

@container FullAnalysis_files (max-width: 700px) {
    .FullAnalysis_files{
        --cols: 2;
    } 
}

@container FullAnalysis_files (max-width: 400px) {
    .FullAnalysis_files{
        --cols: 1;
    } 
}

.FullAnalysis_folder_info{

}

.FullAnalysis_folder_icon{
    width: 28px;
    height: 28px;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    flex-shrink: 0;
}


.FullAnalysis_folder_name{
    font-weight: 600;
    font-size: 11px;
    line-height: 14px;
    display: flex;
    align-items: center;

    color: #000000;
}

.FullAnalysis_folder_date{
    font-weight: 400;
    font-size: 8px;
    line-height: 12px;
    align-items: center;

    color: #606060;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/fullAnalysis/FullAnalysis.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,cAAc;AAClB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,cAAc;IACd,aAAa;IACb,mBAAmB;;IAEnB,6BAA6B;IAC7B,qCAAqC;IACrC,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,uCAAuC;;IAEvC,4BAA4B;IAC5B,yCAAyC;;IAEzC,uBAAuB;IACvB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,iCAAiC;IACjC,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,mCAAmC;IACnC,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,mCAAmC;IACnC,oCAAoC;AACxC;;;AAGA;IACI,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,yDAAgP;IAChP,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,qCAAqC;IACrC,iCAAiC;IACjC,yCAAyC;AAC7C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;;IAEZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,wFAAwF;IACxF,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,SAAS;AACb;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;;AAEA;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;IAC5B,cAAc;AAClB;;;AAGA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;;IAEnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;;IAEnB,cAAc;AAClB","sourcesContent":[".FullAnalysis{  \n    /*background-color: #f9f9f9;*/\n    background-color: #f9f9f6;\n    width: 100%;\n    height: 100%;\n    padding-top: 36px;\n    padding-left: 20px;\n    padding-right: 34px;\n    padding-bottom: 20px;\n}\n\n.FullAnalysis_form{\n    padding: 10px;\n    padding-right: 18px;\n}\n\n.FullAnalysis_header{\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 12px;\n}\n\n.FullAnalysis_title{\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 19px;\n\n    color: #8E9ABB;\n}\n\n\n.FullAnalysis_content{\n    display: flex;\n    flex-direction: column;\n    gap: 33px;\n}\n\n.FullAnalysis_breadcrumbs_head{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    /*margin-bottom: 33px;*/\n}\n\n.FullAnalysis_breadcrumbs{\n    display: flex;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    gap: 2px;\n}\n\n.FullAnalysis_breadcrumbs_solaris{\n    margin-bottom: 20px;\n}\n\n.FullAnalysis_crumb{\n    font-weight: 400;\n    font-size: 13px;\n    line-height: 16px;\n\n    color: #1d1d1f;\n    display: flex;\n    align-items: center;\n    \n    /* Minimalistic macOS style */\n    background: rgba(255, 255, 255, 0.85);\n    backdrop-filter: blur(20px);\n    border-radius: 6px;\n    padding: 4px 8px;\n    margin: 1px;\n    border: 0.5px solid rgba(0, 0, 0, 0.04);\n    \n    /* Subtle shadow for depth */\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n    \n    /* Smooth transitions */\n    transition: all 0.15s ease;\n    cursor: pointer;\n}\n\n.FullAnalysis_crumb:hover{\n    background: rgba(255, 255, 255, 0.95);\n    border-color: rgba(0, 0, 0, 0.08);\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n}\n\n.FullAnalysis_crumb--drop{\n    color: #007aff;\n    background: rgba(0, 122, 255, 0.12);\n    border-color: rgba(0, 122, 255, 0.2);\n}\n\n.FullAnalysis_crumb--dropError{\n    color: #ff3b30;\n    background: rgba(255, 59, 48, 0.12);\n    border-color: rgba(255, 59, 48, 0.2);\n}\n\n\n.FullAnalysis_crumb::after{\n    content: '';\n    display: block;\n    margin-left: 6px;\n    width: 12px;\n    height: 12px;\n    background-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><path d=\"M4.5 2L8.5 6L4.5 10\" stroke=\"%23999\" stroke-width=\"1.5\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>');\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n    opacity: 0.6;\n}\n\n.FullAnalysis_crumb:last-child{\n    font-weight: 500;\n    background: rgba(255, 255, 255, 0.95);\n    border-color: rgba(0, 0, 0, 0.06);\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n}\n\n.FullAnalysis_crumb:last-child::after{\n    display: none;\n}\n\n.FullAnalysis_crumb:first-child{\n    /*if single crumb*/\n    font-weight: 400;\n}\n\n.FullAnalysis_tabButtons{\n    display: flex;\n    justify-content: center;\n    gap: 5px;\n    background: #F3F6FF;\n    border-radius: 8px;\n    padding: 2px;\n    flex-shrink: 0;\n}\n\n.FullAnalysis_tabButton{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 12px;\n    height: 28px;\n    \n    font-weight: 400;\n    font-size: 14px;\n    line-height: 22px;\n    color: #212633;\n}\n\n.FullAnalysis_tabButton--active{\n    font-weight: 600;\n    background: #FFFFFF;\n    border: 0.5px solid #E2E9FC;\n    box-shadow: 0px 3px 8px rgba(209, 215, 234, 0.12), 0px 3px 1px rgba(209, 215, 234, 0.04);\n    border-radius: 8px;\n}\n\n.FullAnalysis_files_block{\n    container-type: inline-size;\n    container-name: FullAnalysis_files;\n}\n\n.FullAnalysis_files{\n    display: flex;\n    flex-wrap: wrap;\n    gap: 5px;\n    --cols: 3;\n}\n\n@container FullAnalysis_files (max-width: 700px) {\n    .FullAnalysis_files{\n        --cols: 2;\n    } \n}\n\n@container FullAnalysis_files (max-width: 400px) {\n    .FullAnalysis_files{\n        --cols: 1;\n    } \n}\n\n.FullAnalysis_folder_info{\n\n}\n\n.FullAnalysis_folder_icon{\n    width: 28px;\n    height: 28px;\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n    flex-shrink: 0;\n}\n\n\n.FullAnalysis_folder_name{\n    font-weight: 600;\n    font-size: 11px;\n    line-height: 14px;\n    display: flex;\n    align-items: center;\n\n    color: #000000;\n}\n\n.FullAnalysis_folder_date{\n    font-weight: 400;\n    font-size: 8px;\n    line-height: 12px;\n    align-items: center;\n\n    color: #606060;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
